<template>
  <div class="trial-container">
    <el-card class="trial-lesson-box" header="Lesson Generator">
      <el-form
        :model="user"
        status-icon
        :rules="rules"
        ref="user"
        label-position="top"
        @keydown.enter.native="submitForm('user')"
      >
        <el-form-item :label="$t('triallesson.login.form.email')" prop="email">
          <el-input
            ref="email"
            type="text"
            v-model="user.email"
            autocomplete="off"
            @change="error = null"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('triallesson.login.form.password')" prop="code">
          <el-input
            type="text"
            v-model="user.code"
            autocomplete="off"
            class="code"
            @blur="error = null"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <div id="login-error">{{ error }}</div>
          <el-button type="primary" @click="submitForm('user')" class="login">
            {{ $t('triallesson.login.form.login') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { store } from '@/utils/common';

export default {
  data() {
    return {
      user: {
        page_url: null,
        code: '',
        email: ''
      },
      rules: {
        email: [
          {
            required: true,
            message: this.$t('triallesson.login.validation.emptyEmail'),
            trigger: 'blur'
          },
          {
            type: 'email',
            message: this.$t('triallesson.login.validation.validEmail'),
            trigger: ['blur', 'change']
          }
        ],
        code: [
          {
            required: true,
            message: this.$t('triallesson.login.validation.emptyPassword'),
            trigger: 'blur'
          },
          {
            max: 10,
            message: this.$t('triallesson.login.validation.validPassword'),
            trigger: 'blur'
          }
        ]
      },
      error: null
    };
  },
  computed: {
    ...mapState('triallesson', [
      'pageUrl',
      'trialLessonCredentials',
      'isTrialLessonCreated'
    ])
  },
  watch: {
    error: function(value) {
      if (value !== null) {
        document.getElementById('login-error').style.display = 'block';
      } else {
        document.getElementById('login-error').style.display = 'none';
      }
    }
  },
  mounted() {
    this.$nextTick(() => this.$refs.email.focus())
  },
  methods: {
    ...mapMutations('triallesson', ['setTrialLessonLoginSuccess']),
    ...mapActions('triallesson', [
      'authenticateUser',
      'createLesson',
      'getTrialLessonLists'
    ]),
    submitForm(formName) {
      this.error = null;
      this.$refs[formName].validate(async valid => {
        if (!valid) {
          return false;
        }

        this.user.page_url = this.pageUrl;
        try {
          await this.authenticateUser(this.user);
          if (!this.trialLessonCredentials.valid) {
            this.error = this.$t('triallesson.login.validation.notValid');
            return false;
          }

          Object.assign(this.user, {pageExpires: this.trialLessonCredentials.expirationDate});
          store.setLessonGeneratorCredentials(this.pageUrl, this.user);

          await this.getTrialLessonLists({
            ...this.user,
            serviceId: this.$route.params.serviceId
          });
          this.setTrialLessonLoginSuccess(true);
        } catch (error) {
          if (error.graphQLErrors && error.graphQLErrors.length > 0) {
            this.error = error.graphQLErrors[0].message || this.$t('triallesson.warnings.checkValidCredentials');
          } else {
            this.error = this.$t('triallesson.warnings.unexpectedError');
          }

          return false;
        }
      });
    }
  }
};
</script>
